<mat-dialog-content>
  <div class="flex-column gap-10">
    <div class=" flex-row gap-5 start-center">
      <span>{{ 'trendAnalysis.currentValue' | translate }} </span
        ><button class="label {{ 'label-' | kpiLabel: data.kpiLine.kpis.CPI.kpiColor }}" disabled>
        &lt;Q{{ data.kpiLine.kpis.CPI.kpiValue }}&gt;
      </button>
    </div>
    @if (trendAnalysisResult?.prediction && trendAnalysisResult?.prediction?.tendency) {
      <div
        class="flex-row start-center"
        >
        @if (daysUntilNewKpi) {
          <span>
            {{ 'trendAnalysis.prediction1' | translate }}
            <b> {{ trendAnalysisResult.prediction.futureKpiValue }} </b> {{ 'trendAnalysis.prediction2' | translate }}
            @if (daysUntilNewKpi <= maxPredictionDays) {
              <b> {{ daysUntilNewKpi }}</b>
            }
            @if (daysUntilNewKpi > maxPredictionDays) {
              <b> {{ maxPredictionDays }}+</b>
            }
            {{ 'trendAnalysis.prediction3' | translate }}
          </span>
        }
        {{ 'trendAnalysis.tendency' | translate }}:
        @switch (trendAnalysisResult.prediction.tendency) {
          @case ('WILL_IMPROVE') {
            <mat-icon class="up-arrow"> trending_up </mat-icon>
          }
          @case ('WILL_STAY_THE_SAME') {
            <mat-icon class="flat-arrow"> trending_flat </mat-icon>
          }
          @case ('WILL_WORSEN') {
            <mat-icon class="down-arrow"> trending_down </mat-icon>
          }
        }
      </div>
    }
    @if (!isLoading && !trendAnalysisResult?.prediction?.ratings) {
      <span>{{
        'trendAnalysis.noForecast' | translate
      }}</span>
    }
    <div [hidden]="isLoading">
      @if (chartDataAvailable) {
        <h3 mat-dialog-title class="margins">{{ 'trendAnalysis.forecast' | translate }}</h3>
        <div style="width: 320px; height: 320px">
          <canvas #chartCanvasTrends width="320" height="320"></canvas>
        </div>
      }
    </div>
  </div>
  @if (isLoading) {
    <colimo-loader [isRelative]="true" style="width: 50%; height: 50%;"></colimo-loader>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close tabindex="-1">Ok</button>
</mat-dialog-actions>
